// extracted by mini-css-extract-plugin
export default {"red-dot":"index_red-dot__Bsq1d","dot":"index_dot__+31-Y","key":"index_key__liHuM"};